import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../../lib/appmonitorlogic';

export default function AppMonitor() {
  const location = useLocation();

  // Initialize once on mount
  useEffect(() => {
    initAnalytics();
  }, []);

  // Track every route change
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}